import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import languages from "@/locales/languages.json";
import {
  getCachedLanguage,
  setCachedLanguage,
} from "@/core/utils/languageCache";
import type { TranslationResource, FindLocaleBy } from "./locales.types";

const resources: TranslationResource = {};

languages.forEach((language) => {
  const filepath = `./${language.translation_file_locale}.json`;
  let translation = null;
  try {
    translation = require(`${filepath}`);
  } catch (err) {
    console.error("Translation file not found", err);
    return;
  }

  resources[language.translation_file_locale] = {
    translation,
  };
});

// Get cached language from localStorage or default to English
const getInitialLanguage = (): string => {
  const cachedLang = getCachedLanguage();
  if (cachedLang && resources[cachedLang]) {
    return cachedLang;
  }
  return "en";
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export function strings(name: string, params = {}) {
  return i18n.t(name, params);
}

export function setLocale(
  locale: number | string,
  findBy: FindLocaleBy = "id",
) {
  if (!locale) {
    console.warn("No locale provided!");
    return;
  }

  const language = languages.find(({ id, culture }) => {
    if (findBy === "id") return id === locale;

    return culture.toLowerCase() === locale.toString().toLowerCase();
  });
  if (!language) {
    console.warn("No locale found!", locale);
    return;
  }

  // Check if language is already set to avoid duplicate calls
  if (i18n.language === language.translation_file_locale) {
    console.debug("Language already set to:", language.culture);
    return;
  }

  // Cache the language preference in localStorage
  setCachedLanguage(language.translation_file_locale);

  i18n.changeLanguage(language.translation_file_locale, (error: string) => {
    if (error) {
      console.warn("Error in changing language to:", language.culture, error);
    } else {
      console.info("Language set to:", language.culture);
    }
  });
}
